<template>
    <div class="hd_tit">
        <!-- <p class="txt01" :style="txt01" v-if="file.val3 != ''">
            {{ file.val3 }}
        </p> -->
        <p class="txt01" :style="txt01" v-if="file.val3 != ''"
            v-html="$options.filters.newLineToBrTrim(file.val3)">
        </p>
        <p class="txt02" :style="txt02" v-if="file.val11 != ''"
            v-html="$options.filters.newLineToBrTrim(file.val11)">
        </p>
        <!-- {{ file.val11 }} -->
        <p class="txt03" :style="txt03" v-if="file.val19 != ''"
            v-html="$options.filters.newLineToBrTrim(file.val19)">
        </p>
        <!-- {{ file.val19 }} -->
        <p class="txt04" :style="txt04" v-if="file.val27 != ''"
            v-html="$options.filters.newLineToBrTrim(file.val27)">
        </p>
            <!-- <span v-show="file.val27 != ''">{{ file.val27 }}</span> -->
    </div>
</template>

<script>
import { $_WC } from "@/confs/common.const";

export default {
    name: "WelcomeText",
    props: {
        file: {
            type: Object,
            default: {},
        },
    },

    data() {
        return {
            vc: ($_WC.viewScale <= 1 ? 3 : 1),
        }
    },

    computed: {
        txt01() {
            let shadowSize = 3 / this.vc;

            let textShadow = this.file.val7 == 'Y' ? shadowSize + "px " + shadowSize + "px " + shadowSize + "px #000" : "none";
            let fontSize = this.file.val6 == '' ? 97 :  this.file.val6;
            let fontFamily = this.file.valNm4 == '' ? "Noto Sans KR" : this.file.valNm4;
            let color = this.file.val5 == '' ? "#ffffff" : this.file.val5;
            let textAlign = this.file.val8 == '' ? "center" : this.file.val8;
            let left = this.file.val9 == '' ? 0 : this.file.val9;
            let top = this.file.val10 == '' ? 0 : this.file.val10;
            return this.getStyle(textShadow, fontSize, fontFamily, color, textAlign, left, top);
        },
        txt02() {
            let shadowSize = 6 / this.vc;

            let textShadow = this.file.val15 == 'Y' ? shadowSize + "px " + shadowSize + "px " + shadowSize + "px #000" : "none";
            let fontSize = this.file.val14 == '' ? 180 :  this.file.val14;
            let fontFamily = this.file.valNm12 == '' ? "Noto Sans KR" : this.file.valNm12;
            let color = this.file.val13 == '' ? "#ffffff" : this.file.val13;
            let textAlign = this.file.val16 == '' ? "center" : this.file.val16;
            let left = this.file.val17 == '' ? 0 : this.file.val17;
            let top = this.file.val18 == '' ? 0 : this.file.val18;
            return this.getStyle(textShadow, fontSize, fontFamily, color, textAlign, left, top);
        },
        txt03() {
            let shadowSize = 6 / this.vc;

            let textShadow = this.file.val23 == 'Y' ? shadowSize + "px " + shadowSize + "px " + shadowSize + "px #000" : "none";
            let fontSize = this.file.val22 == '' ? 135 :  this.file.val22;
            let fontFamily = this.file.valNm20 == '' ? "Noto Sans KR" : this.file.valNm20;
            let color = this.file.val21 == '' ? "#ffffff" : this.file.val21;
            let textAlign = this.file.val24 == '' ? "center" : this.file.val24;
            let left = this.file.val25 == '' ? 0 : this.file.val25;
            let top = this.file.val26 == '' ? 0 : this.file.val26;
            return this.getStyle(textShadow, fontSize, fontFamily, color, textAlign, left, top);
        },
        txt04() {
            let shadowSize = 1 / this.vc;

            let textShadow = this.file.val31 == 'Y' ? shadowSize + "px " + shadowSize + "px " + shadowSize + "px #000" : "none";
            let fontSize = this.file.val30 == '' ? 52 :  this.file.val30;
            let fontFamily = this.file.valNm28 == '' ? "Noto Sans KR" : this.file.valNm28;
            let color = this.file.val29 == '' ? "#ffffff" : this.file.val29;
            let textAlign = this.file.val32 == '' ? "center" : this.file.val32;
            let left = this.file.val33 == '' ? 0 : this.file.val33;
            let top = this.file.val34 == '' ? 0 : this.file.val34;
            return this.getStyle(textShadow, fontSize, fontFamily, color, textAlign, left, top);
        },
    },

    methods: {
        getStyle(textShadow, fontSize, fontFamily, color, textAlign, left, top) {
            return {
                position: 'relative',
                fontFamily: fontFamily,
                color: color,
                fontSize: (fontSize / this.vc) + 'px',
                textShadow: textShadow,
                width: '100%',
                textAlign: textAlign,
                left: (left / this.vc) + 'px',
                top: (top / this.vc) + 'px',
            }
        }
    },
}
</script>
<style>
.txt01{width: 96% !important; left: 2%;}
.txt02{width: 96% !important; left: 2%;}
.txt03{width: 96% !important; left: 2%;}
.txt04{width: 96% !important; left: 2%;}
</style>
